<template>
  <v-flex xs12 row>
  	<v-layout row wrap>
  		<v-flex xs12>
  			
  		</v-flex>
  	</v-layout>

	<v-layout py-3>
   		<v-flex xs12>
   			<v-form v-model="validForm">
          <v-card>
            <v-card-title class="px-4">
              <v-flex xs12 sm2>
                <div class="subheading text-uppercase">
                  <span>Purchase No.: </span>
                  <span>{{purchase.id}}</span>
                </div>
                <div class="py-2">
                  <v-text-field slot="input" v-model="purchase.bill_number" label="Bill No." :readonly="viewMode"></v-text-field>
                </div>
              </v-flex>
              <v-flex xs12 sm7 class="text-xs-center">
                <span class="headline text-uppercase font-weight-light pt-4" v-text="`${pageType} Purchase`"></span>
              </v-flex>
              <v-flex xs12 sm3 class="text-xs-right">
                <div class="body-2 py-2" v-if="viewMode">
                  <span>Purchase Type: </span>
                  <span v-text="isProductPurchase ? 'Product' : 'Raw Material'"></span>
                </div>
                <div class="body-2 font-weight-light py-2 pl-3">
                  <v-dialog v-if="!viewMode" ref="dialog" v-model="dateModal" :return-value.sync="purchase.date" persistent lazy full-width width="290px">
                    <v-text-field slot="activator" v-model="purchase.date" label="Purchase Date" prepend-icon="event" readonly
                    ></v-text-field>
                    <v-date-picker v-model="purchase.date" @input="$refs.dialog.save(purchase.date)" :max="maxDate" :min="minDate"></v-date-picker>
                  </v-dialog>
                  <v-text-field v-else v-model="purchase.date" label="Purchase Date" prepend-icon="event" readonly
                    ></v-text-field>
                  <v-text-field slot="input" v-model="purchase.vendor" label="Vendor Name" :readonly="viewMode"></v-text-field>
                </div>
              </v-flex>
            </v-card-title>

            <v-card-text>

              <v-container grid-list-md py-0 v-if="!viewMode">

                <v-layout wrap>
                  <v-flex xs12 sm4 class="pl-2">
                    <v-radio-group v-model="purchase.purchase_type" :disabled="!!purchase.id" row>
                      <v-radio label="Product" :value="1"></v-radio>
                      <v-radio label="Raw Material" :value="2"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs5 sm3 v-if="isProductPurchase">
                    <v-autocomplete :loading="itemCodeLoading" v-model="itemId" :search-input.sync="itemCodeSearch" :items="searchItems" item-text="item_code" item-value="id" label="Search Item Code" hide-no-data>
                      <template slot="item" slot-scope="data">
                        <v-list-tile-content>
                          <v-list-tile-title v-text="data.item.item_code"></v-list-tile-title>
                          <v-list-tile-sub-title class="caption" v-text="data.item.category_name"></v-list-tile-sub-title>
                        </v-list-tile-content>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs7 sm5>
                    <v-autocomplete :loading="itemNameLoading" v-model="itemId" :search-input.sync="itemNameSearch" :items="searchItems" item-text="title" item-value="id" label="Search Item Name" hide-no-data>
                      <template slot="item" slot-scope="data">
                        <v-list-tile-content>
                          <v-list-tile-title v-text="data.item.title"></v-list-tile-title>
                          <v-list-tile-sub-title v-if="isProductPurchase" class="caption" v-text="data.item.category_name"></v-list-tile-sub-title>
                        </v-list-tile-content>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-container>

              <v-container>
                <v-layout wrap>
                  <v-flex xs12>
                    <div>
                      <div class="v-table__overflow">
                        <table class="v-datatable v-table">
                          <thead>
                            <tr>
                              <th role="columnheader" scope="col" class="column text-xs-left" v-if="isProductPurchase">
                                <span>Item Code</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-left">
                                <span>Item Name</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-left">
                                <span>Unit</span>
                              </th>
                              <th role="columnheader" scope="col" class="column" :class="viewMode ? 'text-xs-right' : 'text-xs-left'">
                                <span>QTY</span>
                              </th>
                              <th role="columnheader" scope="col" class="column" :class="viewMode ? 'text-xs-right' : 'text-xs-left'">
                                <span>Rate ({{currency}})</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-right">
                                <span>Tax (%)</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-right">
                                <span>Amount ({{currency}})</span>
                              </th>
                              <th role="columnheader" scope="col" class="column text-xs-right" v-if="!viewMode">
                                <span>Actions</span>
                              </th>
                            </tr>
                          </thead>
                          <tbody v-if="purchase.items && purchase.items.length > 0">
                            <tr is="purchase-item" v-for="(item, index) in purchase.items" :item="item" :index="index" @delete="deleteItem" :viewMode="viewMode" :showCode="isProductPurchase"></tr>
                          </tbody>
                          <tbody v-else>
                            <tr>
                              <td colspan="8">No Items Added</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm6 md8>
                    <v-layout class="align-start justify-end column fill-height pr-3">
                      <div class="body-2" v-if="amountInWords">
                        <span class="grey--text text--darken-2">Total Amount (In Words): </span>
                        <span class="font-weight-light">{{amountInWords}}</span>
                      </div>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm6 md4 class="text-xs-right justify-end py-3 pl-3 pr-3">
                    <table class="total-table">
                      <tbody>
                        <tr class="body-2">
                          <td width="66%">Subtotal ({{currency}}): </td>
                          <td width="34%">{{ viewMode ? purchase.subtotal : subtotal | roundValue }}</td>
                        </tr>
                        <tr class="body-1">
                          <td>Discount: </td>
                          <td><span v-if="purchase.discount > 0">-</span>{{ purchase.discount | roundValue }}</td>
                        </tr>
                        <tr class="body-1">
                          <td>Roundoff ({{currency}}): </td>
                          <td v-if="viewMode">{{ purchase.round_off | roundValue }}</td>
                          <td v-else>
                            <v-edit-dialog color="white" :return-value.sync="round_off" lazy @open="openRoundOff" @close="closeRoundOff" class="text-xs-right justify-end"> {{ purchase.round_off | roundValue }}
                              <v-text-field type="number" :rules="roundOffRules" slot="input" v-model="round_off" label="Enter Amount" single-line></v-text-field>
                            </v-edit-dialog>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <v-divider class="my-2"></v-divider>
                    <table class="total-table">
                      <tbody>
                        <tr class="body-1 font-weight-medium" v-if="tax > 0">
                          <td width="66%">Total Amount ({{currency}}): </td>
                          <td width="34%">{{ viewMode ? purchase.total : total | roundValue }}</td>
                        </tr>
                        <tr class="body-1 font-weight-medium" v-if="tax > 0">
                          <td width="66%">GST ({{ purchase.tax_percent }}%): </td>
                          <td width="34%">{{ viewMode ? purchase.tax : tax | roundValue }}</td>
                        </tr>
                        <tr class="subheading font-weight-medium">
                          <td width="66%">Grand Total ({{currency}}): </td>
                          <td width="34%">{{ viewMode ? purchase.grandtotal : grandtotal | roundValue }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </v-flex>
                </v-layout>
              </v-container>

            </v-card-text>

            <v-card-actions v-if="!viewMode">
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat :disabled="processing" to="/purchase-list">Cancel</v-btn>
              <v-btn color="blue darken-1" flat :disabled="!validForm || processing" :loading="processing" @click.native="purchase.id ? updatePurchase() : savePurchase()" v-text="purchase.id ? 'Update' : 'Save'"></v-btn>
            </v-card-actions>
          </v-card>
        </v-form>

   		</v-flex>

   	</v-layout>
    
  </v-flex>
</template>

<script>
  
  import PurchaseItem from './PurchaseItem'

  export default {
    name: 'Purchase',
    props: {
      viewMode: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
      	title: "Purchase",
        dateModal: false,
        validForm: false,
      	processing: false,
        itemCodeLoading: false,
        itemNameLoading: false,
        itemId: null,
        itemCodeSearch: "",
        itemNameSearch: "",
        searchItems: [],
        taxEnabled: false,
        tax_percent: 18,
        round_off: 0,
        purchase: {},
        maxDate: this.today('YYYY-MM-DD'),
        minDate: this.formatMysqlDate(Date.now() - ( 1000 * 60 * 60 * 24 * 6 ), 'YYYY-MM-DD'),//before 1 week
        defaultPurchase: {
          id: "",
          date: this.today('YYYY-MM-DD'),
          purchase_type: 1,
          items: [],
          round_off: 0,
          discount: 0,
          tax_percent: 0,
          tax: 0,
          bill_number: "",
          vendor: "",
        },
        nameRules: [
            v => !!v || 'Name is required',
            v => v && v.length >= 4 || 'Must be more than 3 characters',
            v => v && v.length <= 50 || 'Maximum 50 characters allowed'
        ],
        requireRule: [
          v => !!v || 'Field is required'
        ],
        codeRules: [
            v => !!v || 'Item code is required',
            v => v && v.length >= 4 || 'Must be more than 3 characters',
            v => v && v.length <= 20 || 'Maximum 20 characters allowed'
        ],
        rateRules: [
            v => !!v || 'Rate is required',
            v => /^([0-9]{2,7})$/.test(v) || 'Rate must be valid'
        ],
        roundOffRules: [
          v => !!v || 'Amount is required',
          v => /^-?\s*(?=.*[0-9])\d*(?:\.\d{1,2})?\s*$/.test(v) || 'Amount must be valid'
        ],

      }
    },
    created () {
      	let breadcrumbs = [
	      	{
	          text: 'Dashboard',
	          disabled: false,
	          href: '/dashboard'
	        },
	        {
	          text: 'Purchase',
            disabled: false,
            href: '/purchase-list'
	        },
	        {
	          text: this.viewMode ? 'View' : this.$route.params.purchaseId ? 'Edit' : 'Add',
	          disabled: true
	        }
       ]

      this.$store.commit('setBreadcrumbs', breadcrumbs)
      this.$store.commit('setPageTitle', 'Manage Purchase')
    },
    methods: {

      searchItemsByCode () {

      	let api_path = `${this.config.apis.searchItems}?item_code=${this.itemCodeSearch}&include_parent=true`
        this.itemCodeLoading = true
        this.axios.get(api_path)
        .then((response) => {
            this.itemCodeLoading = false
            if (this.isSuccessResponse(response)) {
              this.searchItems = response.data.data
            }
        })
        .catch((error) => {
            this.itemCodeLoading = false
        })
      },

      searchItemsByName () {

        let api_path = ""

        if (this.isProductPurchase) {
        	api_path = `${this.config.apis.searchItems}?title=${this.itemNameSearch}&include_parent=true`
        }
        else{
        	api_path = `${this.config.apis.searchRawMaterials}?title=${this.itemNameSearch}`
        }

        this.itemNameLoading = true
        this.axios.get(api_path)
        .then((response) => {
            this.itemNameLoading = false
            if (this.isSuccessResponse(response)) {
              this.searchItems = response.data.data
            }
        })
        .catch((error) => {
            this.itemNameLoading = false
        })
      },

      upsertItemFromListToPurchase (val) {

        let exist = this.purchase.items.findIndex(item => item.item_id === val)

        // if item already exists, then increase quantity else add new item
        if (exist !== -1) {
          this.purchase.items[exist].quantity++
          this.clearItemAutoComplete()
        }
        else{
          let item = this.searchItems.filter(item => item.id === val)

          if (item.length > 0) {
            item = item[0]
            item.tax = ( ( item.rate * item.tax_percent ) / 100)
            //add new item at the first index of items array
            let new_item = this.extend({quantity:1, total:0, item_id: item.id}, item)
            delete new_item.id
            this.purchase.items.splice(0, 0, new_item)
            this.clearItemAutoComplete()
          }
        }

      },

      clearItemAutoComplete () {
        this.itemCodeSearch = ""
        this.itemNameSearch = ""
        setTimeout(() => {
          this.itemId = null
        }, 100)
      },

      calculateItemTotal (item) {
        return item.quantity * ( item.rate + ( ( item.rate * item.tax_percent ) / 100) )
      },

      updateTax () {
        this.purchase.tax_percent = this.taxEnabled ? this.tax_percent : 0
      },

      savePurchase () {

        if (this.purchase.items.length === 0) return this.notifyError('emptyPurchaseItems')
        if (this.total < 0) return this.notifyError('invalidPurchaseTotal')

        let invalidItems = this.purchase.items.filter(item => item.rate <= 0 || item.quantity <= 0)

        if (invalidItems.length > 0) return this.notifyError('invalidPurchaseItems')

        this.processing = true

        let data = this.extend(this.purchase, {
          total: this.total,
          subtotal: this.subtotal,
          tax: this.tax,
          tax_percent: this.purchase.tax_percent,
          grandtotal: this.grandtotal
        })

        this.axios.post(this.config.apis.savePurchase, data)
          .then((response) => {
            if (this.isSuccessResponse(response)) {

              this.notifySuccess('insertPurchaseSuccess')
              this.$router.push("/purchase-list")
            }
            else{
              this.notifyError('insertError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
          })
      },

      updatePurchase () {
      	
        if (this.purchase.items.length === 0) return this.notifyError('emptyPurchaseItems')
        if (this.total < 0) return this.notifyError('invalidPurchaseTotal')

        let invalidItems = this.purchase.items.filter(item => item.rate <= 0 || item.quantity <= 0)

        if (invalidItems.length > 0) return this.notifyError('invalidPurchaseItems')

        this.processing = true

        let data = this.extend(this.purchase, {
          total: this.total,
          subtotal: this.subtotal,
          tax: this.tax,
          tax_percent: this.purchase.tax_percent,
          grandtotal: this.grandtotal
        })

        this.axios.put(this.config.apis.updatePurchase.replace(":id", data.id), data)
          .then((response) => {
            if (this.isSuccessResponse(response)) {

              this.notifySuccess('updatePurchaseSuccess')
              this.$router.push("/purchase-list")
            }
            else{
              this.notifyError('insertError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
          })
      },

      deleteItem (index) {
        this.purchase.items.splice(index, 1)
      },

      initNewPurchase () {
        this.purchase = this.extend({}, this.defaultPurchase)
      },

      loadPurchase (purchaseId) {
        this.processing = true
        this.axios.get(this.config.apis.getPurchase.replace(":id", purchaseId))
          .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
              this.purchase = response.data.data
              this.taxEnabled = this.purchase.tax_percent > 0
            }
            else{
              this.purchase = this.initNewPurchase()
            }
          })
          .catch((error) => {
            this.processing = false
          })
      },

      openRoundOff () {
        this.round_off = parseFloat(this.purchase.round_off)
      },

      closeRoundOff () {
        this.purchase.round_off = parseFloat(this.round_off ? this.round_off : this.purchase.round_off)
      },

    },
    mounted () {
      if (this.$route.params.purchaseId) {
        this.loadPurchase(this.$route.params.purchaseId)
      }
      else{
        this.initNewPurchase()
      }
      
    },

    computed: {

      subtotal () {
        
        let total = 0
        
        if (this.purchase.items) {
          this.purchase.items.forEach( item => {
            total += item.total
          })
        }
        
        return total
      },

      total () {
        return ( this.subtotal + this.purchase.round_off ) - ( this.purchase.discount )
      },

      tax () {
        return this.purchase.tax_percent * 100 / this.total
      },

      grandtotal () {
        return this.tax + this.total
      },

      pageType () {
        return this.viewMode ? 'View' : this.$route.params.purchaseId ? 'Update' : 'Add'
      },

      amountInWords () {
        return this.amountToWords(this.grandtotal)
      },

      isProductPurchase () {
        return this.purchase.purchase_type == this.config.purchaseTypes.product
      },

    },

    watch: {

      '$route' (to, from) {
        // react to route changes...
        if (to !== from && to.params.purchaseId) {
          this.loadPurchase(to.params.purchaseId)
        }
        else{
          this.purchase = this.initNewPurchase()
        }

      },

      itemCodeSearch (val, oldVal) {
        if (val && val != oldVal) {
          this.searchItemsByCode()
        }
      },

      itemNameSearch (val, oldVal) {
        if (val && val != oldVal) {
          this.searchItemsByName()
        }
      },

      itemId (val, oldVal) {
        if (val && val !== oldVal) {
          this.upsertItemFromListToPurchase(val)
        }
      },

      'purchase.round_off' (val, oldVal) {
        if (!val) {
          this.purchase.round_off = 0
        }
      },

      'purchase.purchase_type' (val, oldVal) {
        if (val && !this.purchase.id) {
          this.purchase.items = []
          this.clearItemAutoComplete()
          this.searchItems = []
        }
      },

    },
    
    components: {
      'purchase-item': PurchaseItem,
    }

  }
</script>
